import { Button, Dropdown, Tag } from 'antd';
import { DeleteOutlined, FilterFilled, FilterOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

export const getAirwayBillColumns = ({ handleDelete, selectedCustomer, onCustomerChange, customers }) => [
  {
    title: '空运单号',
    dataIndex: 'airway_bill_number',
    key: 'airway_bill_number',
    width: '12%',
  },
  {
    title: () => {
      const items = [
        { key: '', label: '全部' },
        ...customers?.map(customer => ({
          key: customer.id,
          label: `(${customer.airway_bill_count})${customer.company_name}`
        })) || []
      ];

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          客户
          <Dropdown
            menu={{
              items,
              selectedKeys: [selectedCustomer?.customer],
              onClick: ({ key }) => onCustomerChange('customer', key || undefined)
            }}
            trigger={['click']}
          >
            <FilterFilled 
              style={{ cursor: 'pointer', fontSize: '12px', color: selectedCustomer?.customer ? '#1890ff' : undefined }}
              onClick={e => e.stopPropagation()}
            />
          </Dropdown>
        </div>
      );
    },
    dataIndex: ['customer_details', 'username'],
    key: 'customer',
    width: '10%',
  },
  {
    title: '落地口岸',
    dataIndex: 'port_of_entry_name',
    key: 'port_of_entry',
    width: '10%',
  },
  {
    title: '批次号',
    dataIndex: 'batch_count',
    key: 'batch_count',
    width: '7%',
  },
  {
    title: '订单数量',
    dataIndex: 'order_count',
    key: 'order_count',
    width: '7%',
  },
  {
    title: '提单件数',
    dataIndex: 'bill_count',
    key: 'bill_count',
    width: '7%',
  },
  {
    title: '包裹数量',
    dataIndex: 'package_count',
    key: 'package_count',
    width: '7%',
  },
  {
    title: () => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        状态
        <Dropdown
          menu={{
            items: [
              { key: '', label: '全部' },
              { key: 'SHIPPING', label: '运输中' },
              { key: 'PENDING_CUSTOMS', label: '待清关' },
              { key: 'RELEASED', label: '已放行' }
            ],
            selectedKeys: [selectedCustomer?.public_status],
            onClick: ({ key }) => onCustomerChange('public_status', key || undefined)
          }}
          trigger={['click']}
        >
          <FilterFilled 
            style={{ 
              cursor: 'pointer', 
              fontSize: '12px', 
              color: selectedCustomer?.public_status ? '#1890ff' : undefined 
            }}
            onClick={e => e.stopPropagation()}
          />
        </Dropdown>
      </div>
    ),
    dataIndex: 'public_status',
    key: 'public_status',
    width: '10%',
    render: (publicStatus, record) => {
      // If internal status is RELEASED, show as RELEASED regardless of public_status
      const displayStatus = record.status === 'RELEASED' ? 'RELEASED' : publicStatus;
      
      const statusConfig = {
        'SHIPPING': { label: '运输中', color: '#1890ff' },
        'PENDING_CUSTOMS': { label: '待清关', color: '#722ed1' },
        'RELEASED': { label: '已放行', color: '#52c41a' }
      };
      const config = statusConfig[displayStatus] || { label: displayStatus, color: '#d9d9d9' };
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
          <Tag color={config.color} style={{ margin: 0, fontSize: '14px', padding: '6px 12px' }}>
            {config.label}
          </Tag>
        </div>
      );
    }
  },
  {
    title: () => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        额外补税
        <Dropdown
          menu={{
            items: [
              { key: '', label: '全部' },
              { key: 'true', label: '是' },
              { key: 'false', label: '否' }
            ],
            selectedKeys: [selectedCustomer?.is_additional_tax_notes],
            onClick: ({ key }) => onCustomerChange('is_additional_tax_notes', key || undefined)
          }}
          trigger={['click']}
        >
          <FilterFilled 
            style={{ 
              cursor: 'pointer', 
              fontSize: '12px', 
              color: selectedCustomer?.is_additional_tax_notes !== undefined ? '#1890ff' : undefined 
            }}
            onClick={e => e.stopPropagation()}
          />
        </Dropdown>
      </div>
    ),
    dataIndex: 'is_additional_tax_notes',
    key: 'is_additional_tax_notes',
    width: '8%',
    render: (value) => value ? '✓' : '',
    align: 'center'
  },
  {
    title: () => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        理赔包裹
        <Dropdown
          menu={{
            items: [
              { key: '', label: '全部' },
              { key: 'true', label: '是' },
              { key: 'false', label: '否' }
            ],
            selectedKeys: [selectedCustomer?.is_claim_package_notes],
            onClick: ({ key }) => onCustomerChange('is_claim_package_notes', key || undefined)
          }}
          trigger={['click']}
        >
          <FilterFilled 
            style={{ 
              cursor: 'pointer', 
              fontSize: '12px', 
              color: selectedCustomer?.is_claim_package_notes !== undefined ? '#1890ff' : undefined 
            }}
            onClick={e => e.stopPropagation()}
          />
        </Dropdown>
      </div>
    ),
    dataIndex: 'is_claim_package_notes',
    key: 'is_claim_package_notes',
    width: '8%',
    render: (value) => value ? '✓' : '',
    align: 'center'
  },
  {
    title: () => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        账单核对
        <Dropdown
          menu={{
            items: [
              { key: '', label: '全部' },
              { key: 'true', label: '是' },
              { key: 'false', label: '否' }
            ],
            selectedKeys: [selectedCustomer?.is_processed],
            onClick: ({ key }) => onCustomerChange('is_processed', key || undefined)
          }}
          trigger={['click']}
        >
          <FilterFilled 
            style={{ 
              cursor: 'pointer', 
              fontSize: '12px', 
              color: selectedCustomer?.is_processed !== undefined ? '#1890ff' : undefined 
            }}
            onClick={e => e.stopPropagation()}
          />
        </Dropdown>
      </div>
    ),
    dataIndex: 'is_processed',
    key: 'is_processed',
    width: '8%',
    render: (value) => value ? '✓' : '',
    align: 'center'
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => dayjs(date).format('M-D H:mm'),
    width: '8%',
  },
  {
    title: '操作',
    key: 'action',
    render: (_, record) => (
      <Button 
        type="text" 
        danger 
        size="small"
        icon={<DeleteOutlined style={{ fontSize: '12px' }} />} 
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(record);
        }}
      >
        <span style={{ fontSize: '12px' }}>删除</span>
      </Button>
    ),
  },
];

export const getBatchColumns = () => [
  {
    title: '批次号',
    dataIndex: 'batch_number',
    key: 'batch_number',
  },
  {
    title: '客户',
    dataIndex: 'customer_name',
    key: 'creator_name',
  },
  {
    title: '订单数量',
    dataIndex: 'order_count',
    key: 'order_count',
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
  }
];

export const getOrderColumns = () => [
  {
    title: '订单号',
    dataIndex: 'order_number',
    key: 'order_number',
  },
  {
    title: '客户',
    dataIndex: 'customer_name',
    key: 'customer_name',
  },
  {
    title: '收件人',
    dataIndex: 'recipient_name',
    key: 'recipient_name',
  },
  {
    title: '电话',
    dataIndex: 'recipient_phone',
    key: 'recipient_phone',
  },
  {
    title: '地址',
    dataIndex: 'recipient_address',
    key: 'recipient_address',
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
  },
];
